import React from 'react';
import { cn } from '../lib/utils';

interface Logo {
  name: string;
  path: string;
}

const LOGOS: Logo[] = [
  { name: 'Beckman Coulter', path: '/logos/beckman-coulter.png' },
  { name: 'TC Energy', path: '/logos/tc-energy.png' },
  { name: '8x8', path: '/logos/8x8.png' },
  { name: 'Aetna', path: '/logos/aetna.png' },
  { name: 'SaskPower', path: '/logos/saskpower.png' },
  { name: 'Global Worldwide', path: '/logos/global-worldwide.png' },
  { name: 'Life Extension', path: '/logos/life-extension.png' },
  { name: 'Sixbell', path: '/logos/sixbell.png' },
  { name: 'Telcel', path: '/logos/telcel.png' },
];

const LogoScroll: React.FC = () => {
  return (
    <section className="py-8 md:py-12 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-4">
          Trusted by forward-thinking organizations
        </h2>
        
        <div className="relative w-full overflow-hidden">
          {/* Gradient overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10" />
          
          <div 
            className="flex"
            style={{
              animation: 'scroll 30s linear infinite',
              width: 'fit-content'
            }}
          >
            {/* First set of logos */}
            {LOGOS.map((logo, index) => (
              <div
                key={`first-${index}`}
                className="flex-shrink-0 w-64 h-64 mx-8 flex items-center justify-center"
              >
                <img
                  src={logo.path}
                  alt={`${logo.name} logo`}
                  className="w-48 h-48 object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
                  loading="lazy"
                />
              </div>
            ))}
            
            {/* Duplicate set for seamless loop */}
            {LOGOS.map((logo, index) => (
              <div
                key={`second-${index}`}
                className="flex-shrink-0 w-64 h-64 mx-8 flex items-center justify-center"
              >
                <img
                  src={logo.path}
                  alt={`${logo.name} logo`}
                  className="w-48 h-48 object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        <style jsx>{`
          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
        `}</style>
      </div>
    </section>
  );
};

export default LogoScroll; 